export default "__VITE_ASSET__80ca4643__"